import { AudiologyFileInput } from '../AudiologyFileInput/AudiologyFileInput'

interface Props {
    poid: File | null
    utilityBill: File | null
    onPoidChange: (file: File | null) => void
    onUtilityBillChange: (file: File | null) => void
    required?: boolean
    disabled?: boolean
}

export const IdentityDocumentsInput = ({
    poid,
    utilityBill,
    onPoidChange,
    onUtilityBillChange,
    required,
    disabled,
}: Props) => (
    <>
        <AudiologyFileInput
            id="mhl-field-poid"
            file={poid}
            onChange={onPoidChange}
            required={required}
            disabled={disabled}
            label="Proof of ID"
            emptyTitle="Click to choose proof of ID, or drop it here"
            emptySub="Passport, driving licence, or national ID. All four corners visible."
            previewAlt="Proof of ID preview"
        />
        <AudiologyFileInput
            id="mhl-field-utility-bill"
            file={utilityBill}
            onChange={onUtilityBillChange}
            required={required}
            disabled={disabled}
            label="Utility bill"
            emptyTitle="Click to choose a utility bill, or drop it here"
            emptySub="A recent bill showing the client's name and address."
            previewAlt="Utility bill preview"
        />
    </>
)
